import React from 'react';
import { Route } from 'react-router-dom';

function RefreshRoute({ path }) {
  return (
    <Route
      path={path}
      component={({ history, location, match }) => {
        history.replace({
          ...location,
          pathname: location.pathname.substring(match.path.length),
        });
        return null;
      }}
    />
  );
}

export default RefreshRoute;
